'use client'

import { AppInsightsContext } from '@microsoft/applicationinsights-react-js'
import { ReactNode, useEffect } from 'react'

import { initializeAppInsights, reactPlugin } from './AppInsights'

import { RUTA_RELEVO_TELEMETRIA } from '@/app/lib/relevoTelemetria'
import { getRuntimeConfig } from '@/core/config/runtimeConfig'

interface IConfigAppInsightsContainerProps {
  children: ReactNode
}

const ConfigAppInsightsContainer: React.FC<IConfigAppInsightsContainerProps> = ({ children }) => {
  useEffect(() => {
    // ConfigRuntimeProvider (padre en el árbol) garantiza que la config ya está hidratada
    const { APPINSIGHTS_CONNECTION_STRING, IS_PRODUCTION, REGION, BASE_URL } = getRuntimeConfig()

    initializeAppInsights({
      connectionString: APPINSIGHTS_CONNECTION_STRING,
      ambiente: IS_PRODUCTION ? 'produccion' : 'pruebas',
      region: REGION,
      backendUrl: BASE_URL,
      // Mismo origen que la página: los bloqueadores filtran por host y a este no lo tocan.
      endpointRelevo: `${window.location.origin}${RUTA_RELEVO_TELEMETRIA}`,
    })
  }, [])

  return <AppInsightsContext.Provider value={reactPlugin}>{children}</AppInsightsContext.Provider>
}

export default ConfigAppInsightsContainer
